import { InjectionToken } from '@angular/core';

export const HOST = new InjectionToken<string>('HOST');
export const PATH = new InjectionToken<string>('PATH');
export const ORIGIN = new InjectionToken<string>('ORIGIN');
export const PROTOCOL = new InjectionToken<string>('PROTOCOL');